var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.action.element,{key:_vm.action.id,ref:"actionElement",tag:"component",domProps:{"share":_vm.share,"node":_vm.node,"onSave":_setup.onSave}})
}
var staticRenderFns = []

export { render, staticRenderFns }